var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', [_c('div', {
    staticClass: "splash-card position-relative elevate d-flex flex-column justify-content-center py-4"
  }, [_c('div', {
    staticClass: "container px-3 px-md-0"
  }, [_c('img', {
    staticClass: "d-block mx-auto mb-4 small",
    staticStyle: {
      "z-index": "1",
      "max-width": "50%"
    },
    attrs: {
      "src": "/epp/content/isbe-logo2.png"
    }
  }), _c('h2', {
    staticClass: "d-none d-md-block text-center"
  }, [_vm._v("Preparing Tomorrow's Teachers Today")]), _c('h4', {
    staticClass: "d-md-none d-block text-center"
  }, [_vm._v("Preparing Tomorrow's Teachers Today")]), _vm._m(0), _vm._m(1), _vm._m(2), _c('h3', {
    staticClass: "d-none d-md-block text-center mt-3 text-muted"
  }, [_vm._v("Explore Teacher Preparation in Illinois")]), _c('h5', {
    staticClass: "d-block d-md-none text-center mt-2 text-muted"
  }, [_vm._v("Explore Teacher Preparation in Illinois")]), _c('div', {
    staticClass: "row no-gutters mt-5"
  }, [_c('router-link', {
    staticClass: "col-md mr-md-4 mr-0 mb-4 mb-md-0 btn btn-primary raised",
    staticStyle: {
      "font-size": "1.5rem"
    },
    attrs: {
      "to": "/institutions",
      "tag": "button"
    }
  }, [_vm._v(" I want to recruit and hire teachers ")]), _c('router-link', {
    staticClass: "col-md btn btn-primary raised",
    staticStyle: {
      "font-size": "1.5rem"
    },
    attrs: {
      "to": "/institutions",
      "tag": "button"
    }
  }, [_vm._v(" I want to prepare to be a teacher ")])], 1), _c('div', {
    staticClass: "row mt-4 no-gutters"
  }, [_c('SearchModal', {
    staticClass: "elevate col bg-primary border-primary pointer",
    attrs: {
      "placeholder": "I want to see a specific program...",
      "input-classes": "h4 pointer",
      "input-icon-classes": "h4 text-white",
      "result-classes": "list-group"
    }
  })], 1), _c('div', {
    staticClass: "divider dashed mt-4"
  }), _c('div', {
    staticClass: "row mt-4 no-gutters"
  }, [_c('router-link', {
    attrs: {
      "to": "/state-report"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        navigate
      }) {
        return [_c('button', {
          staticClass: "col-md btn btn-outline-primary mb-3 mb-md-0",
          staticStyle: {
            "background-color": "#fff"
          },
          attrs: {
            "type": "button"
          },
          on: {
            "click": navigate
          }
        }, [_c('i', {
          staticClass: "fas fa-chart-pie"
        }), _vm._v(" State Report ")])];
      }
    }])
  }), _vm._m(3), _c('a', {
    staticClass: "col-md btn btn-outline-primary",
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "href": _vm.ExternalResources.TechnicalGuide,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fas fa-tools"
  }), _vm._v(" Technical Guide ")])], 1), _c('div', {
    staticClass: "bg"
  }), _c('div', {
    staticClass: "bg-fill"
  })])]), _c('div', {
    staticClass: "container py-4 px-3 px-md-0"
  }, [_c('div', {
    staticClass: "card mt-4"
  }, [_c('div', {
    staticClass: "card-body p-4 text-center"
  }, [_c('h3', [_vm._v("What does Illinois offer?")]), _c('div', {
    staticClass: "row pt-3 m-auto",
    staticStyle: {
      "max-width": "800px"
    }
  }, [_c('div', {
    staticClass: "col-sm"
  }, [_c('div', {
    staticClass: "m-0 text-secondary display-4"
  }, [_vm._v(_vm._s(_vm.institutionCount))]), _c('div', {
    staticClass: "m-0 h5"
  }, [_vm._v("Institutions")])]), _c('div', {
    staticClass: "col-sm text-center"
  }, [_c('div', {
    staticClass: "m-0 text-secondary display-4"
  }, [_vm._v(_vm._s(_vm.programCount))]), _c('div', {
    staticClass: "m-0 h5"
  }, [_vm._v("Programs")])]), _c('div', {
    staticClass: "col-sm text-center"
  }, [_c('div', {
    staticClass: "m-0 text-secondary display-4"
  }, [_vm._v(_vm._s(_vm.programs.length))]), _c('div', {
    staticClass: "m-0 h5"
  }, [_vm._v("Endorsement Areas")])])])])]), _c('div', {
    staticClass: "card mt-4"
  }, [_c('div', {
    staticClass: "card-body p-4 text-sm-left text-center"
  }, [_c('h3', [_vm._v("What are the Illinois Educator Preparation Profiles?")]), _c('p', {
    staticClass: "card-text pt-1",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_vm._v(" Illinois Educator Preparation Profile (IEPP) provides a holistic view of each teaching program in the state. This includes a program's ability to select and prepare effective educators to serve the students and schools of Illinois. The IEPP system is an opportunity to both recognize programs that are producing strong learner-ready teachers, and to utilize data as a tool for accountability, continuous improvement and transparency to strengthen teacher preparation statewide in the long term. ")]), _c('EmbeddedVideo')], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('router-link', {
    attrs: {
      "to": "/about?scrollTo=%23detail"
    }
  }, [_vm._v("See what data is used to calculate the IEPP "), _c('i', {
    staticClass: "fas fa-chevron-circle-right ml-1"
  })])], 1)]), _vm._m(4)])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h1', {
    staticClass: "d-none d-lg-block text-center text-primary display-4 font-weight-bold text-shadow"
  }, [_vm._v(" ILLINOIS EDUCATOR "), _c('br'), _vm._v(" PREPARATION PROFILE ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h1', {
    staticClass: "d-none d-md-block d-lg-none text-center text-primary font-weight-bold text-shadow"
  }, [_vm._v(" ILLINOIS EDUCATOR "), _c('br'), _vm._v(" PREPARATION PROFILE ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h2', {
    staticClass: "d-block d-md-none text-center text-primary font-weight-bold text-shadow"
  }, [_vm._v(" ILLINOIS EDUCATOR "), _c('br'), _vm._v(" PREPARATION PROFILE ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    staticClass: "col-md btn btn-outline-primary mx-md-3 mx-0 mb-3 mb-md-0",
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "href": "#",
      "onclick": "window.open('/epp/public/download', '_blank')"
    }
  }, [_c('i', {
    staticClass: "fas fa-download"
  }), _vm._v(" Download Data ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card mt-4"
  }, [_c('div', {
    staticClass: "card-body p-4"
  }, [_c('h3', {
    staticClass: "text-sm-left text-center"
  }, [_vm._v("How can you use these profiles?")]), _c('div', {
    staticClass: "d-flex flex-sm-row flex-column text-sm-left text-center align-items-center"
  }, [_c('div', {
    staticClass: "bg-primary flex-shrink-0 h4 text-white m-0 section-icon mt-4",
    staticStyle: {
      "border-radius": "100%"
    }
  }, [_c('i', {
    staticClass: "fas fa-graduation-cap"
  })]), _c('p', {
    staticClass: "card-text pt-2 pt-sm-4 ml-0 ml-sm-3",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold d-block"
  }, [_vm._v("PROSPECTIVE EDUCATORS")]), _vm._v(" Search for teaching programs that best meet their needs. ")])]), _c('div', {
    staticClass: "d-flex flex-sm-row flex-column text-sm-left text-center align-items-center pt-4 pt-sm-0"
  }, [_c('div', {
    staticClass: "bg-primary flex-shrink-0 h4 mt1 text-white m-0 section-icon mt-4",
    staticStyle: {
      "border-radius": "100%"
    }
  }, [_c('i', {
    staticClass: "fas fa-school"
  })]), _c('p', {
    staticClass: "card-text pt-2 pt-sm-4 ml-0 ml-sm-3",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold d-block"
  }, [_vm._v("SCHOOL & DISTRICT STAFF")]), _vm._v(" Explore programs to focus their recruitment and hiring efforts, and to build new partnerships. ")])]), _c('div', {
    staticClass: "d-flex flex-sm-row flex-column text-sm-left text-center align-items-center pt-4 pt-sm-0"
  }, [_c('div', {
    staticClass: "bg-primary flex-shrink-0 h4 mt1 text-white m-0 section-icon mt-4",
    staticStyle: {
      "border-radius": "100%"
    }
  }, [_c('i', {
    staticClass: "fas fa-tools"
  })]), _c('p', {
    staticClass: "card-text pt-2 pt-sm-4 ml-0 ml-sm-3",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold d-block"
  }, [_vm._v("EDUCATION PREPARATION PROVIDERS")]), _vm._v(" Find programs for collaborating, working on improvements, and sharing best practices. ")])])])]);
}];
export { render, staticRenderFns };